import { useState } from "react";
import { Mail, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/Reveal";
import { subscribeNewsletter } from "@/lib/api";

export const Newsletter = () => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle");

    const submit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setStatus("loading");
        try {
            const res = await subscribeNewsletter(email.trim());
            setStatus("done");
            toast.success(res.message || "Inscrição confirmada.");
        } catch (err) {
            setStatus("idle");
            toast.error(err.response?.data?.detail?.[0]?.msg || "Não foi possível concluir a inscrição. Tente novamente.");
        }
    };

    return (
        <section id="newsletter" data-testid="newsletter-section" className="bg-gold text-ink">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                    <Reveal>
                        <span className="text-xs uppercase tracking-[0.3em] font-semibold text-ink/60">Newsletter semanal</span>
                        <h2 className="font-serif text-3xl md:text-5xl tracking-tight mt-3 leading-tight">
                            Um e-mail por semana.<br />
                            <span className="italic">Zero jargão.</span>
                        </h2>
                        <p className="mt-4 text-sm md:text-base text-ink/70 max-w-md leading-relaxed">
                            Toda segunda-feira: um conceito de finanças explicado em 5 minutos de leitura.
                            Sem spam, sem venda de dados, cancele quando quiser.
                        </p>
                    </Reveal>

                    <Reveal delay={0.15}>
                        {status === "done" ? (
                            <div data-testid="newsletter-success" className="flex items-center gap-4 border border-ink/20 p-6">
                                <CheckCircle2 size={28} className="shrink-0" />
                                <div>
                                    <p className="font-serif text-xl">Você está dentro.</p>
                                    <p className="text-sm text-ink/70 mt-1">O próximo e-mail chega na segunda-feira.</p>
                                </div>
                            </div>
                        ) : (
                            <form data-testid="newsletter-form" onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
                                <div className="relative flex-1">
                                    <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-ink/50" />
                                    <input
                                        data-testid="newsletter-email-input"
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="seu@email.com.br"
                                        className="w-full bg-ink/[0.06] border border-ink/25 focus:border-ink outline-none pl-11 pr-4 py-4 text-sm placeholder:text-ink/40 text-ink transition-colors"
                                    />
                                </div>
                                <button
                                    data-testid="newsletter-submit-button"
                                    type="submit"
                                    disabled={status === "loading"}
                                    className="bg-ink text-white font-medium px-8 py-4 text-sm hover:bg-surface transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
                                >
                                    {status === "loading" && <Loader2 size={15} className="animate-spin" />}
                                    Quero receber
                                </button>
                            </form>
                        )}
                    </Reveal>
                </div>
            </div>
        </section>
    );
};
